import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonRow } from '../../layout/ButtonRow';
import { FlexContainer } from '../../layout/FlexContainer';
export const DialogButtonRow = ({ children, ...spacing }) => {
    return (_jsx(FlexContainer, { horizontalAlign: 'right', ...spacing, children: _jsx(ButtonRow, { children: children }) }));
};
